export default "__VITE_ASSET__2GWU3Q4z__"